import React from "react";

type TechStackItem = {
  icon: string;
  title: string;
  items: string[];
};

type TechStackSectionProps = {
  title: string;
  description: string;
  techStack: TechStackItem[];
};

const TechStackSection: React.FC<TechStackSectionProps> = ({
  title,
  description,
  techStack,
}) => {
  return (
    <section className="tech-stack section" style={{ padding: "48px 0" }}>
      <div className="container">

        <h3 className="details-content-title">{title}</h3>
        <p style={{ color: "#ccc", marginTop: 8, maxWidth: 700 }}>
          {description}
        </p>

        <div style={{ marginTop: 32, display: "grid", gap: 28 }}>
          {techStack.map((t, i) => (
            <div
              key={i}
              className="wow fadeInUp"
              data-wow-delay={`${i * 50}ms`}
              style={{
                display: "flex",
                alignItems: "center",
                background: "#15121f",
                padding: 24,
                borderRadius: 18,
                border: "1px solid rgba(255,255,255,0.06)",
                gap: 24,
                minHeight: 160,
                transition: "0.25s ease",
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.transform = "translateY(-6px)";
                el.style.boxShadow = "0 12px 30px rgba(0,0,0,0.25)";
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.transform = "translateY(0)";
                el.style.boxShadow = "none";
              }}
            >

              {/* LEFT ICON PANEL */}
              <div
                style={{
                  width: 110,
                  height: "100%",
                  minHeight: 110,
                  background: "rgba(0,0,0,0.25)",
                  borderRadius: 16,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 16,
                }}
              >
                <img
                  src={t.icon}
                  alt={t.title}
                  style={{
                    width: 64,
                    height: 64,
                    objectFit: "contain",
                  }}
                />
              </div>

              {/* RIGHT CONTENT */}
              <div style={{ flex: 1 }}>
                <h4
                  style={{
                    fontSize: 20,
                    color: "#fff",
                    marginBottom: 16,
                    fontWeight: 600,
                  }}
                >
                  {t.title}
                </h4>

                {/* TAG GRID */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  {t.items.map((item, index) => (
                    <span
                      key={index}
                      style={{
                        padding: "6px 14px",
                        background: "rgba(255,255,255,0.1)",
                        borderRadius: 6,
                        fontSize: 14,
                        color: "#ddd",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStackSection;
